'use client';

import { useStore } from '@/providers/app-store-provider';
import { IS_US } from '@/utils/constants';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

interface PublicResourceLike {
  jsonvalues?: {
    compliance_subscription_display?: {
      switch?: number | string;
    };
  };
}

const MARKETING_STATUS_ROUTE_WHITELIST = [
  // common
  '/search-result',
  '/goods-list',
  '/goods-detail',
  '/cart',
  '/coupons',
  '/account/account-security',
  '/account/communication-preferences',
  '/account/my-address-book',

  // pc
  // m
];

export const useComplianceMarketingStatusInit = () => {
  const pathname = usePathname();
  const token = useStore((state) => state.token);
  const clientTokenReady = useStore((state) => state.clientTokenReady);
  const publicResourceData = useStore((state) => state.publicResourceData as PublicResourceLike);
  const setComplianceMarketingStatus = useStore((state) => state.setComplianceMarketingStatus);
  const getMarketingStatus = useStore((state) => state.getMarketingStatus);

  const config = publicResourceData?.jsonvalues?.compliance_subscription_display || {};
  const switchValue = config.switch;
  const isSubscriptionDisplayEnabled =
    IS_US && !!token && (switchValue === 1 || switchValue === '1');
  const isRouteEnabled = MARKETING_STATUS_ROUTE_WHITELIST.some((path) => pathname?.includes(path));

  useEffect(() => {
    if (!clientTokenReady) return;

    if (!isSubscriptionDisplayEnabled || !isRouteEnabled) {
      setComplianceMarketingStatus(undefined);
      return;
    }

    setComplianceMarketingStatus(undefined);
    getMarketingStatus();
  }, [
    clientTokenReady,
    getMarketingStatus,
    isRouteEnabled,
    isSubscriptionDisplayEnabled,
    pathname,
    setComplianceMarketingStatus,
    token,
  ]);
};
